module.exports = __webpack_public_path__ + "img/linux-adv-04-preview.0091fb37.jpg";